// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8rHbr","footer":"styles_footer__3Vmk1","passCodeTooltip":"styles_passCodeTooltip__XFhwb"};